import { useRequiredCustomerId } from "hooks/use-customer-id";
import { usePermission } from "hooks/use-permissions";
import { useEffect } from "react";
import { Outlet } from "react-router";
import { useRootStore } from "store";

export default function CustomerLayout() {
  const customerId = useRequiredCustomerId();
  const { fetchCustomer } = useRootStore((state) => state.customers);
  const { fetchDashboard } = useRootStore((state) => state.dashboard);
  const { getInventories } = useRootStore((state) => state.inventory);
  const isExternalUser = usePermission("isExternal");
  const { isAuthenticated } = useRootStore((state) => state.user);

  useEffect(() => {
    // Fetch customer data when customerId changes
    if (!isAuthenticated) {
      return;
    }
    fetchCustomer(customerId);
    fetchDashboard(customerId);
    if (isExternalUser) {
      getInventories(customerId);
    }
  }, [
    customerId,
    fetchCustomer,
    fetchDashboard,
    getInventories,
    isExternalUser,
    isAuthenticated
  ]);

  return (
    <>
      <Outlet />
    </>
  );
}
